export default function CustomerBalanceView({ balance, loading }) {
  return (
    <div className="rounded-lg border p-4 bg-white dark:bg-gray-900 dark:border-gray-700">
      <h3 className="text-sm font-medium text-gray-600 dark:text-gray-400">
        Saldo Credit Customer
      </h3>
      <div className="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-100">
        {loading
          ? "Loading..."
          : `Rp ${Number(balance).toLocaleString("id-ID")}`}
      </div>
    </div>
  );
}
